export const INPUT_TYPES = {
  field: 'field',
  variable: 'variable',
  related_field: 'related_field',
  business_plugin_config: 'business_plugin_config',
  static_value: 'static_value',
} as const;

export const OUTPUT_TYPES = {
  field: 'field',
  variable: 'variable',
  related_field: 'related_field',
} as const;

export const CONFLICT_RESOLUTIONS = {
  overwrite: 'overwrite',
  add_only: 'add_only',
  remove_only: 'remove_only',
  update_if_blank: 'update_if_blank',
  overwrite_except_null: 'overwrite_except_null',
} as const;
